import { Suspense } from 'react';

import { useRouteParams } from '@trello/router';
import { type RouteId } from '@trello/router/routes';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPowerUpDirectory = () => {
  // TODO: Swap this for useSearchParams from React Router, once this route is migrated
  // https://reactrouter.com/api/hooks/useSearchParams
  const queryParams = new URLSearchParams(window.location.search);
  const query = queryParams.get('q') || '';

  // TODO: Swap this for useParams from React Router, once this route is migrated
  // https://reactrouter.com/api/hooks/useParams
  const routeParams =
    useRouteParams<typeof RouteId.POWER_UP_PUBLIC_DIRECTORY>();
  const PowerUpDirectory = useLazyComponent(
    () =>
      import(/* webpackChunkName: "power-up-directory" */ './PowerUpDirectory'),
    {
      namedImport: 'PowerUpDirectory',
    },
  );
  return (
    <Suspense fallback={null}>
      <PowerUpDirectory
        section={routeParams.section}
        subsection={routeParams.subsection}
        query={query}
      />
    </Suspense>
  );
};
